module.exports = __webpack_public_path__ + "media/styles/images/svg/pencil-teal-on-white-a65703dc5b5cd544be5c62a06c2eb42a.svg";